// extracted by mini-css-extract-plugin
export default {"CardExample":"CardExample--fr5zc","CardExample__link":"CardExample__link--oRYtC"};